export default __webpack_public_path__ + "static/media/787.9611e2a0.gif";